import type { INextTriggerInfo } from '@/interfaces'

class NextTriggerInfo implements INextTriggerInfo {
  nextJobTaskId: string
  nextJobTaskNumber: number
  dueAt: string
  remainingTimespan?: string
  remainingTimeText?: string
  targetOdometerReading?: number
  odometerUnit?: string
  targetMachineHours?: number
  lastUpdatedAt?: string

  constructor(nextTriggerInfo?: any) {
    this.nextJobTaskId = nextTriggerInfo?.nextJobTaskId
    this.nextJobTaskNumber = nextTriggerInfo?.nextJobTaskNumber
    this.dueAt = nextTriggerInfo?.dueAt
    this.remainingTimespan = nextTriggerInfo?.remainingTimespan
    this.remainingTimeText = nextTriggerInfo?.remainingTimeText
    this.targetOdometerReading = nextTriggerInfo?.targetOdometerReading
    this.odometerUnit = nextTriggerInfo?.odometerUnit
    this.targetMachineHours = nextTriggerInfo?.targetMachineHours
    this.lastUpdatedAt = nextTriggerInfo?.lastUpdatedAt
  }
}

export default NextTriggerInfo
